import { Charge } from './charge.model';

export interface TicketClearCodeTypes {
	codeId: number;
	types: ClearCodeType[];
}

export interface ClearCodeType {
	cctId: number;
	desc: string;
	order: number;
}

export interface TicketClearCodeOptions {
	cctId: number;
	options: ClearCodeOption[];
}

export interface ClearCodeOption {
	id: number;
	desc: string;
	childOptions: number[];
}

export class ClearCode {
	note = '';
	codes = [] as ClearCodeState[];
	charges = [] as Charge[];

	constructor(init?: Partial<ClearCode>) {
		Object.assign(this, init);
	}
}

export class AppointmentClearCode {
	appointmentId: number;
	codeId: number;
	clearCode = new ClearCode();

	constructor(init?: Partial<AppointmentClearCode>) {
		Object.assign(this, init);
	}
}

export interface ClearCodeState {
	ticketClearCodeType: ClearCodeType;
	ticketClearCodeOption: ClearCodeOption;
}

export interface TicketClearCodeAllowed {
	tcId: number;
	allowed: number[];
}

export class ClearAppointment {
	appointmentId: number;
	ticketClearCodeIds: number[];
	note: string;
	timestamp: string;
	charges: any[];

	constructor(init?: Partial<ClearAppointment>) {
		Object.assign(this, init);
	}
}
